import { render, staticRenderFns } from "./StatisticsCornersGoalsDesktop.vue?vue&type=template&id=e7b3b194&scoped=true&"
import script from "./StatisticsCornersGoalsDesktop.vue?vue&type=script&lang=js&"
export * from "./StatisticsCornersGoalsDesktop.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsCornersGoalsDesktop.vue?vue&type=style&index=0&id=e7b3b194&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b3b194",
  null
  
)

export default component.exports